/* LIMTEH studio events: StudioOpen and DesignSaved for the Design It Yourself studio.
   Fires Meta pixel custom events (through Shopify's customer-privacy-aware pixel) and GA4 if present.
   Read-only on the page: it only listens for clicks and the ?design= return URL. */
(function () {
  if (window.__ltStudioEvents) return;
  window.__ltStudioEvents = true;

  function consented() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
    } catch (e) {}
    return !/_tracking_consent=[^;]*"mkt":false/.test(document.cookie);
  }

  function product() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return { handle: m ? m[1] : '', product_id: meta ? String(meta.id) : '' };
  }

  function send(name, params) {
    if (!consented()) return;
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('limteh_' + name.toLowerCase(), params);
      }
    } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
  }

  // 1. StudioOpen: click on the studio button (app block link to /apps/design/editor)
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('a[href*="/apps/design/editor"]');
    if (!a) return;
    var p = product();
    var ps = {};
    try { ps = Object.fromEntries(new URL(a.href, location.origin).searchParams); } catch (e) {}
    send('StudioOpen', { content_name: p.handle, content_ids: [p.product_id], variant_id: ps.variant || '', content_type: 'product' });
  }, true);

  // 2. DesignSaved: the studio returns to the product page with ?design=<id>. Fire once per design id.
  try {
    var id = new URLSearchParams(location.search).get('design');
    if (id) {
      var key = 'lt_design_' + id;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        var p2 = product();
        send('DesignSaved', { content_name: p2.handle, content_ids: [p2.product_id], design_id: id, content_type: 'product' });
      }
    }
  } catch (e) {}
})();
